import React, { useState } from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { useRouter } from 'next/router'

export interface AuthorItemProps {
  author: {
    fullName: string
    bio: string
    shortDescription: string
    email: string
    image: any
    slug?: string
  }
  alwaysShowBio?: boolean
  isLink?: boolean
}

const AuthorItem: React.FC<AuthorItemProps> = ({
  author,
  alwaysShowBio,
  isLink,
}) => {
  const [isBioExpanded, setIsBioExpanded] = useState(false)
  const router = useRouter()

  const handleCardClick = () => {
    if (isLink) {
      router.push(`/author/${author.slug}`)
    }
  }

  const handleToggleBio = e => {
    e.stopPropagation()
    setIsBioExpanded(!isBioExpanded)
  }

  const AuthorCardContent = (
    <>
      <div className={styles.authorImage}>
        <Image
          src={author.image}
          width={140}
          height={140}
          border-radius={50}
          alt="Author's image"
        />
      </div>
      <div className={styles.authorDetails}>
        <div className={styles.name}>{author.fullName}</div>
        <div className={styles.email}>{author.email}</div>
        <div className={styles.shortDescription}>{author.shortDescription}</div>
        <div
          className={
            alwaysShowBio || isBioExpanded
              ? `${styles.bio} ${styles.expanded}`
              : styles.bio
          }
        >
          {author.bio}
        </div>
        {!alwaysShowBio && (
          <div className={styles.readMore} onClick={handleToggleBio}>
            {isBioExpanded ? 'Read Less' : 'Read More'}
          </div>
        )}
      </div>
    </>
  )

  if (isLink) {
    return (
      <div className={styles.authorCard} onClick={handleCardClick}>
        {AuthorCardContent}
      </div>
    )
  }

  return <div className={styles.authorCard}>{AuthorCardContent}</div>
}

export default AuthorItem
